<template>
  <div
    :class="['zg-border', {
      [`zg-border--border-${border}`]: border,
      [`zg-border--background-color-${backgroundColor}`]: backgroundColor,
      [`zg-border--border-color-${borderColor}`]: borderColor,
      'zg-border--flipped-x': flippedX,
      'zg-border--flipped-y': flippedY
    }]"
  >
    <component :is="borderComponent" />
  </div>
</template>

<script>
  const colors = [
    'white',
    'beige',
    'brand-500',
    'brand-300',
    'brand-100',
    'primary-500',
    'secondary-500',
    'gray-500',
    'gray-300',
    'gray-200'
  ]

  export default {
    name: 'ZgBorder',
    components: {
      BorderBrushStroke: () => import('./borders/BrushStroke'),
      BorderClouds: () => import('./borders/Clouds'),
      BorderFooter: () => import('./borders/Footer'),
      BorderPostcard: () => import('./borders/Postcard'),
      BorderWaves: () => import('./borders/Waves')
    },
    props: {
      border: {
        type: String,
        required: false,
        default: null,
        validator: value => !value || [
          'brush-stroke',
          'clouds',
          'footer',
          'postcard',
          'waves'
        ].includes(value)
      },
      backgroundColor: {
        type: String,
        required: false,
        default: 'white',
        validator: value => colors.includes(value)
      },
      borderColor: {
        type: String,
        required: true,
        validator: value => colors.includes(value)
      },
      flippedX: {
        type: Boolean,
        required: false,
        default: false
      },
      flippedY: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      defaultBorder: 'brush-stroke'
    }),
    computed: {
      borderComponent () {
        return `border-${this.border || this.defaultBorder}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  $border-colors: white, beige, brand-500, brand-300, brand-100, primary-500, secondary-500, gray-500, gray-300, gray-200;

  .zg-border {
    position: relative;
    display: block;
    width: 100%;

    & > div,
    ::v-deep svg {
      height: auto;
      width: 100%;
      shape-rendering: crispedges;
    }
  }

  // ? ----------------------------------------------------------------------
  // sizes
  // ? ----------------------------------------------------------------------

  .zg-border {
    ::v-deep div {
      .mobile {
        display: block;

        @include mq(medium) {
          display: none;
        }
      }

      .tablet {
        display: none;

        @include mq(medium) {
          display: block;
        }

        @include mq(large) {
          display: none;
        }
      }

      .desktop {
        display: none;

        @include mq(large) {
          display: block;
        }
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // colors
  // ? ----------------------------------------------------------------------

  @each $item in $border-colors {
    .zg-border--background-color-#{'' + $item} {
      background-color: color($item);
    }

    .zg-border--border-color-#{'' + $item} {
      color: color($item);
    }
  }

  // ? ----------------------------------------------------------------------
  // flipped
  // ? ----------------------------------------------------------------------

  .zg-border--flipped-x {
    transform: scaleX(-100%);
  }

  .zg-border--flipped-y {
    transform: scaleY(-100%);
  }

  .zg-border--flipped-x.zg-border--flipped-y {
    transform: scale(-100%, -100%);
  }
</style>
